import styled from "styled-components";
import { Colors } from '../../../../shared/colors/colors';
import { Dropdown } from 'react-bootstrap';

export const TableContainer = styled.div`
  width: auto;
  border-radius: 8px 8px 0 0;
  overflow: visible !important;
  margin-bottom: 20px;
  position: relative;

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible !important;
    position: relative;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
`;

export const MainContainer = styled.div`
  width: 100%;
`;

// Novos componentes para o menu local
export const FichaFinanceiraMenuTable = styled(Dropdown.Menu)<{ isLastRows?: boolean }>`
  position: absolute;
  right: 95%;
  ${props => props.isLastRows ? 'bottom: calc(100% - 45px);' : 'top: 0;'}
  z-index: 999;
  width: 200px;
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
  transform-origin: ${props => props.isLastRows ? 'bottom right' : 'top right'};
`;

export const FichaFinanceiraMenuItem = styled(Dropdown.Item)`
  padding: 10px 15px;
  font-size: 14px;
  color: ${Colors.primary};
  
  &:hover {
    background-color: #f8f9fa;
  }
  &:active {
    color:${Colors.primary};
  }  
`;

export const FichaFinanceiraMenuDivider = styled(Dropdown.Divider)`
  margin: 0;
`;

// Novos componentes estilizados para substituir o SCSS

export const PageContainer = styled.div`
  width: 100%;
`;

export const BodyTaxpayer = styled.div`
  padding: 20px;
`;

export const FichaFinanceiraTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  h1 {
    font-size: 24px;
    font-weight: 600;
    color: ${Colors.primary};
    margin-bottom: 8px;
  }
`;

export const TitleDivider = styled.div`
  height: 2px;
  background-color: ${Colors.primary};
  width: 70px;
  margin-bottom: 24px;
`;

export const FormLabel = styled.label`
  font-weight: 500;
  color: #212529;
  margin-bottom: 8px;
  display: block;
`;

export const CheckboxImage = styled.img`
  margin-right: 8px;
  vertical-align: middle;
`;

export const TextCenter = styled.td`
  text-align: center;
  color: #6c757d;
`;


export const AppliedFilters = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  min-height: 48px;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 1);
  box-sizing: border-box;
  background: rgba(249, 250, 251, 1);
  font-family: 'Work Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(107, 114, 128, 1);
  margin-top: 16px;

  & > p {
    margin: 0;
    white-space: nowrap;
  }

  & > i.fa.fa-filter {
    color: rgba(107, 114, 128, 1);
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterItem = styled.div`
  border: 2px solid rgba(147, 197, 253, 1);
  border-radius: 4px;
  padding: 4px 8px;
  background-color: rgba(239, 246, 255, 1);
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const FilterKey = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const FilterValue = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;

export const FilterRemoveButton = styled.button`
  background: none;
  border: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
`;